import React from 'react'
import * as S from './ModalOverlay.styles'

import { useModal } from '../../../../contexts/Modal.context'

interface ModalProps {
  foreground?: boolean
  [key: string]: any
}

interface ModalOverlayProps {
  Component?: React.ComponentType<any> | null
  modalProps: ModalProps
  isOpen?: boolean | undefined
  closeModal: () => void
  animateChild?: boolean | undefined
}

const ModalOverlay: React.FC<ModalOverlayProps> = ({ Component, modalProps, isOpen, closeModal, animateChild }) => {
  const { state } = useModal()

  const handleClickOutside = (event: React.MouseEvent<HTMLDivElement>) => {
    if ((event.target as HTMLElement).classList.contains('js-modal-overlay')) {
      closeModal()
    }
  }

  return (
    <S.ModalOverlay 
      isOpen={isOpen} 
      foreground={modalProps.foreground} 
      hasAnnouncementBar={state?.hasAnnouncementBar}
      onClick={handleClickOutside}
      className={'js-modal-overlay'}
    >
      {Component ? <Component {...modalProps} isOpen={animateChild} /> : null}
    </S.ModalOverlay>
  )
}

export default ModalOverlay
